const LocalStorage = function LocalStorage() {};

LocalStorage.get = function (key) {
  return localStorage.getItem(key);
};

LocalStorage.getJSON = function (key) {
  const data = LocalStorage.get(key);
  return JSON.parse(data);
};

LocalStorage.set = function (key, value) {
  return localStorage.setItem(key, value);
};

LocalStorage.setJSON = function (key, value) {
  const data = JSON.stringify(value);
  return LocalStorage.set(key, data);
};

LocalStorage.remove = function (key) {
  return localStorage.removeItem(key);
};

LocalStorage.clean = function () {
  return localStorage.clear();
};

export default LocalStorage;

export const localStorageKey = {
  user: "USER",
};

const parseStoredUser = (raw) => {
  if (!raw) return null;

  // Plain JSON (current format). Legacy SimpleCrypto blobs are dropped → re-login.
  if (raw.trimStart().startsWith("{") || raw.trimStart().startsWith("[")) {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  return null;
};

export const getToken = () => {
  try {
    const user = parseStoredUser(LocalStorage.get(localStorageKey.user));
    return user?.auth_token || null;
  } catch (error) {
    localStorage.removeItem(localStorageKey.user);
    console.error("Error getting token from localStorage:", error);
    return null;
  }
};

export const getUser = () => {
  try {
    const user = parseStoredUser(LocalStorage.get(localStorageKey.user));
    if (!user) {
      // Clear legacy encrypted payloads that can no longer be read
      const raw = LocalStorage.get(localStorageKey.user);
      if (raw) localStorage.removeItem(localStorageKey.user);
      return null;
    }
    return user;
  } catch (error) {
    localStorage.removeItem(localStorageKey.user);
    console.error("Error getting user from localStorage:", error);
    return null;
  }
};

export const getUserDisplayName = (user) => {
  if (!user) return "";

  if (user.name) return user.name;
  if (user.full_name) return user.full_name;

  const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ");
  if (fullName) return fullName;

  return user.email || "Account";
};
